import React, { useContext, lazy, Suspense, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Button, Card, CardContent, Grid, Stack, Tooltip } from "@mui/material";
import { COLOR_MAP } from "../../../constants/ColorNames";
import { resetEmailData, resetFormExceptQueryData, setActiveTab, setCampaignId, setErrorMessages, setJobDescription, setSignature, setTabStates } from '../../../redux/slice/campaignSlice';
import { useGetFAQSQuery, useGetSignatureQuery, usePostCampaignDataMutation, useGetSeekersPendingQuery, usePostResetTrackingMutation } from '../../../redux/services/folderName';
import { ToastContext } from '../../../utils/context/toastContext';
import { RootState } from '../../../redux/store';
import { ProfanityDetailsType, CampaignPostDataType, TabStatesProps, EventPayloadType, LabelValueType, TContentType, DisabledFieldsType } from '../../../types/dataTypes';
import { usePostEventTrackingMutation } from '../../../redux/services/eventTracking';
import { eventTracking } from '../../../utils/eventTracking';
import { ProfanityWordsErrorType, RTKErrorType } from '../../../types/apiResponses';
import { checkForEmptyContent, checkForUrlAndEmail, extractDomain, getCurrencyHexCode, getDisabledFields, getErrorContent, getHexCodeFromCurrency, isValidEmail, removeCommas, replaceAnchorTagsWithPlainText, replaceSpansWithPlaceholders, replaceUrlEmailWithPlainText, stripHtml, updateCampaignPlaceholderValues } from '../../../utils/helpers';
import { MIDDLEWARE_SLUG } from '../../../apis/apiEndPoints';
import { INFO_ICON } from '../../../constants/icons/InfoIcon';
import styled from '@emotion/styled';
import { HELP_ICON } from '../../../constants/icons/HelpIcon';
import HelpDrawer from './HelpDrawer';
import BasicModal from '../../../common/components/Modal';
import { CAMPAIGN_PLACEHOLDERS, campaignPlaceholderMapping, placeholderMapping } from '../../../constants/helpers';
import ProhibitedContent from '../article/Email/ProhibitedContent';
import CampaignPlaceholderInputList from './CampaignPlaceholderInputList';
import { updatedTabStateAfterPlaceholderInput } from '../../../utils/emailHelper';
import { defaultErrorMsg } from '../../../utils/utils';
import {eventPushFunction} from "@foundit/clevertap"
import { campaignMaxLimitSelector } from '../../../redux/selectors/user.selector';

// const AsyncHelpDrawer = lazy(() => import('./HelpDrawer'))


const ToolTipContainer = styled(Grid)`
  padding: 1.2rem;
  color: ${COLOR_MAP.WHITE};
  background-color: ${COLOR_MAP.LIGHT_GREY};
  border-radius: 0.4rem;
  font-family: NOTO SANS;
`;

const TooltipText = styled.p`
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2.2rem;
  margin: 0;
`;

const HelpText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  margin: 0;
  margin-top: 3px;
  color: ${COLOR_MAP.GREY_0};
`

const formatTabState = (tabState: TabStatesProps[]) => {
  return tabState.map((item: TabStatesProps) => {
    return {
      // applyButton: item.applyButton,
      applyButton: true,
      mailBody: item.email,
      mailSubject: item.subject,
      // replyButton: item.replyButton,
      replyButton: true,
      stepNumber: item.stepNumber - 1,
      activeAfterDays: item.selectedFollowUPdays,
    }
  })
}

const getCanidateInputErrorMessage = (errorMessage: string, candidateNo: string, maxLimit:string) => {
  let errorText = 'Please enter count of profile for outreach';
  if (errorMessage === 'The value entered is more than the max limit') {
    errorText = 'The value entered is more than the max limit';
  }
  else if(Number(candidateNo) <= 0){
    errorText = `Count of profile should be greater than 0 and less than or equal to ${maxLimit}.`
  }
  else if (candidateNo) {
    errorText = '';
  }
  return errorText;
}



const getSalaryErrorMessage = (minSalary: string, maxSalary: string) => {
  let errorMessage = '';
  let min = Number(minSalary);
  let max = Number(maxSalary);
 
  if(minSalary && maxSalary && min > max){
    errorMessage = defaultErrorMsg.salaryRange
  }
  return errorMessage;
}

const checkForEmptyCampaignPlaceholder = (tabState: TabStatesProps[],  listOfAllEmptyPlaceholder: Set<string>) => {

  tabState.forEach((item) => {
     const tempDiv = document.createElement('div'); 
    tempDiv.innerHTML = item.email;
      const svgElementArray = tempDiv.querySelectorAll('span > div > svg');

      svgElementArray.forEach((svgElement: any) => {
        if(svgElement){
          const spanWithSVG = svgElement.closest('div');
          const parent = spanWithSVG?.parentElement
          const spanText = parent?.innerText.trim();
          if (spanText) {
            //         // Iterate over the keywords array
                    for (const keyword of CAMPAIGN_PLACEHOLDERS) {
                      // Check if the keyword exists in the span text
                      const index = spanText.indexOf(keyword);
                      if (index !== -1) {
                        // Check if there is any text after the keyword
                        const textAfterKeyword = spanText.substring(index + keyword.length+1).trim();
                        if (textAfterKeyword === '') {
                          // isEmptyPlaceholder = true;
                          listOfAllEmptyPlaceholder.add(keyword)
                        }
                      }
                    }
                  }
        }
      })

  })
//   let isEmptyPlaceholder = false;
//   const tempDiv = document.createElement('div');
//   tempDiv.innerHTML = content;
//  let listOfAllEmptyPlaceholder: string[] = []
//   // Use querySelector to target the span containing the SVG
//   // const svgElement = tempDiv.querySelector('span > span > svg');
//   const svgElementArray = tempDiv.querySelectorAll('span > div > svg');

//   svgElementArray.forEach((svgElement) => {
//     if (svgElement) {
//       const spanWithSVG = svgElement.closest('div');
//       // Get the inner text of the parent span
//       const parent = spanWithSVG?.parentElement
//       const spanText = parent?.innerText.trim();

//       if (spanText) {
//         // Iterate over the keywords array
//         for (const keyword of CAMPAIGN_PLACEHOLDERS) {
//           // Check if the keyword exists in the span text
//           const index = spanText.indexOf(keyword);
//           if (index !== -1) {
//             // Check if there is any text after the keyword
//             const textAfterKeyword = spanText.substring(index + keyword.length).trim();
//             if (textAfterKeyword === '') {
//               isEmptyPlaceholder = true;
//               listOfAllEmptyPlaceholder.push(keyword)
//             }
//           }
//         }
//       }

//     } 
  // })

  // return isEmptyPlaceholder;

}




const ToolTipContent = () => {
  return (
    <ToolTipContainer container spacing={'1.2rem'}>
      <TooltipText>Blast campaign will send the email to all the candidates in one shot.</TooltipText>
      <TooltipText>All other campaigns will be on hold till the time blast campaign is complete</TooltipText>
    </ToolTipContainer>
  )
}

const BlastInfo = (props: { handleBlastCampaign: () => void, disabled: boolean }) => {
  const { handleBlastCampaign, disabled } = props
  return (
    <Tooltip
      title={disabled ? null : <ToolTipContent />} arrow placement="top">
      <Button startIcon={<INFO_ICON fill={disabled ? COLOR_MAP.BUTTON_DISABLED : COLOR_MAP.DARK_PURPLE} />} variant='outlined' disabled={disabled} disableRipple onClick={handleBlastCampaign}>Blast Campaign</Button>
    </Tooltip>
  )
}

const BottomPanel = () => {
  const [showHelpDrawer, setShowHelpDrawer] = useState<boolean>(false);
  const [openBlastModal, setOpenBlastModal] = useState<boolean>(false);
  const [placeholderValues, setPlaceholderValues] = useState<LabelValueType[]>([]);
  const [isPlaceholderModalOpen, setIsPlaceholderModalOpen] = useState<boolean>(false);
  const [campaignType, setCampaignType] = React.useState<string>('');

  const dispatch = useDispatch();
  const {
    folderName,
    folderId,
    candidateNo,
    companyName,
    aboutCompany,
    senderId,
    replyId,
    jobTitle,
    jobLocation,
    maxExperience,
    minExperience,
    maxSalary,
    minSalary,
    campaignName,
    campaignTemplate,
    tabState,
    signature,
    isTemplateForCampaignUsed,
    campaignCreationQueryData,
    campaignId,
    sendMailToContactedProfiles,
    errorMessages,
    contentPersonalisationType,
    contentPersonalisationGenratedViaAI,
    selectedContentPersonalisationKey,
    mediaList,
    isBlastDisabled,
    userData,
    currency,
    jobDescription,
    jobMode,
    passiveJobs,
    selectedContactType,
    outreachType,
    isMaxBlastLimitReached,
    isCampaignTemplateClicked,
    resetDetails
  } = useSelector((state: RootState) => state.campaign);
  const [postCampaignData, { data, isLoading }] = usePostCampaignDataMutation();
  const [postResetTrackingData] = usePostResetTrackingMutation();
  const { setToastValue } = useContext(ToastContext);
  const [postEvent] = usePostEventTrackingMutation();
  const { data: signatureData } = useGetSignatureQuery(1);
  const { data: faqData } = useGetFAQSQuery(1);
  const { data: seekersPending } = useGetSeekersPendingQuery(1);
  let startTime = 0;
  const campaignQueryData = useSelector((state: RootState) => state.campaign.campaignCreationQueryData);
  const triggeredFromPage = campaignQueryData.triggeredFromPage;
  const userDetails = useSelector((state: RootState) => state.campaign.userDetails);
  const media = useSelector((state: RootState) => state.campaign.mediaList);
  const srpDisabledFields = useSelector((state:RootState) => state.campaign.disabledFields)
  const campaignMaxLimit = useSelector(campaignMaxLimitSelector);


  const isBulkCampaign = campaignQueryData.isBulkCampaign === 'true' ? true : false;

  let updatedMinSalary = removeCommas(minSalary);
  let updatedMaxSalary = removeCommas(maxSalary)

  const urlParams = new URLSearchParams(window.location.search);
  const isDraftCampaign = Boolean(urlParams.get('campaignId'));

  const emailContainsProfanity = tabState.some((tab: TabStatesProps) => tab.showError);
  const dissableCampaignInitiation = isLoading || emailContainsProfanity;
  const disableBlast = (isBlastDisabled || isMaxBlastLimitReached) && outreachType === 'BLAST';

  React.useEffect(() => {
    if(!isCampaignTemplateClicked) return;
    setPlaceholderValues([]);
  },[isCampaignTemplateClicked])

  const handleFormReset = React.useCallback(() => {
    dispatch(resetFormExceptQueryData());
  }, [dispatch])



  const scrollToError = () => {
    setTimeout(() => {
      let errorElement = document.querySelector(".Mui-error") as HTMLElement | null;
      if(!errorElement){
        errorElement = document.querySelector(".salaryRange_error") as HTMLElement | null;
      }

      if (errorElement) {
        const offset = errorElement.offsetParent ? (errorElement.offsetParent as HTMLElement).offsetTop : errorElement.offsetTop;
        window.scrollTo({ top: offset - 98, behavior: 'smooth' })
      }
    }, 100);
  };

  // const handleEmailReset = () => {
  //   dispatch(resetEmailData());
  //   if (signatureData && signatureData.sign) {
  //     dispatch(setSignature({ signature: signatureData.sign }));
  //   }
  // }

  const handleCampaignInitiate = (type: string, newTabState?:TabStatesProps[]) => {
    // Check if any field is empty and update error messages accordingly
    let updatedTabState = newTabState ? newTabState : tabState;

    updatedTabState=updatedTabState.map((item: any) => {
      const result = {...item,email: replaceSpansWithPlaceholders(item?.email),subject:replaceSpansWithPlaceholders(item?.subject)}
      
      return result
    })

    setCampaignType(type);
    let newErrorMessages = {
      folderName: !folderName ? 'Please set folder name' : !folderId ? 'Please create the folder' : '',
      replyId: (replyId || outreachType === 'BLAST') && isValidEmail(replyId) ? '' : 'Please enter a valid email ID',
      minExp: minExperience ? '' : 'Please select min experience',
      maxExp: maxExperience ? '' : 'Please select max experience',
      campaignName: campaignName ? '' : 'Please enter campaign name',
      jobTitle: jobTitle ? '' : 'Please enter job title',
      candidateInputNumber: getCanidateInputErrorMessage(errorMessages.candidateInputNumber, candidateNo, campaignMaxLimit),
      salary: getSalaryErrorMessage(updatedMinSalary, updatedMaxSalary),
      jobLocation: (jobMode === 'Remote' || jobLocation?.length) ? '' : 'Please enter job location'
    };

    // Set the error messages state
    dispatch(setErrorMessages({ errorMessages: newErrorMessages }));

    const hasError = Object.keys(newErrorMessages).some(key => newErrorMessages[key as keyof object] !== '');
    const isSubjectEmpty = updatedTabState.some((item: TabStatesProps) => checkForEmptyContent(item.subject));
    const isEmailEmpty = updatedTabState.some((item: TabStatesProps) => checkForEmptyContent(item.email));

    let listOfAllEmptyPlaceholder: Set<string> = new Set([]);
    checkForEmptyCampaignPlaceholder(updatedTabState, listOfAllEmptyPlaceholder)
    if(listOfAllEmptyPlaceholder && listOfAllEmptyPlaceholder.size){
        if(!placeholderValues.length){
          const initialValues = [...listOfAllEmptyPlaceholder].map((label) => ({label: label, value: ''}))
          setPlaceholderValues(initialValues);
        }
        if(!hasError && !isEmailEmpty && !isSubjectEmpty)
        setIsPlaceholderModalOpen(true);
    }

    if (isSubjectEmpty) {
      setToastValue({
        isToastShown: true,
        toastMessage: 'Email subject cannot be empty',
        toastKey: 'campaign-subject-error',
        toastSeverity: 'error'
      })
    }
    if (!isSubjectEmpty && isEmailEmpty) {
      setToastValue({
        isToastShown: true,
        toastMessage: 'Email content cannot be empty',
        toastKey: 'campaign-email-error',
        toastSeverity: 'error'
      })
    }
    scrollToError();
    if (hasError || isSubjectEmpty || isEmailEmpty || (listOfAllEmptyPlaceholder && listOfAllEmptyPlaceholder.size)) return;
    if (type !== 'DRAFT' && outreachType === 'BLAST') {
      setOpenBlastModal(true)
    } else {
      saveCampaignData(type, updatedTabState);
    }
  }

  const getSendMailToContactedProfiles = () => {
    if(triggeredFromPage?.toLowerCase() === "srp" && isBulkCampaign){
      return sendMailToContactedProfiles ? 1 : 0
    }

    return selectedContactType === 'Non-contacted' ? 0 : 1
  }

  const getNewContentType = (): TContentType => {
    if(contentPersonalisationGenratedViaAI){
      return 'AI'
    }

    if(isTemplateForCampaignUsed){
      return 'TEMPLATE'
    }

    return "MANUAL"
  }


  const saveCampaignData = (type: string, updatedTabState?: TabStatesProps[]) => {
    const newTabStates: TabStatesProps[] = JSON.parse(JSON.stringify(updatedTabState ? updatedTabState : tabState));
    newTabStates.forEach((item:TabStatesProps) =>{
      item.email = updateCampaignPlaceholderValues(item.email, false)
      item.subject = updateCampaignPlaceholderValues(item.subject, false);
      item.subject = stripHtml(item.subject);
    });

    const updatedJobDescription = updateCampaignPlaceholderValues(jobDescription, false);

    const formatedTabStateData = formatTabState(newTabStates);
    const disabledFields:(keyof DisabledFieldsType)[] = getDisabledFields(srpDisabledFields)
    const payload: CampaignPostDataType = {
      cover: mediaList.cover,
      logo: mediaList.logo,
      aboutCompany: aboutCompany,
      campaignId: urlParams.get('campaignId'),
      campaignInitiationId: campaignCreationQueryData.campaignInitiationId,
      campaignName: campaignName,
      campaignSteps: formatedTabStateData,
      currencyCode: getHexCodeFromCurrency(currency),
      signature: signature,
      isTemplateUsed: isTemplateForCampaignUsed,
      companyName: companyName,
      folderDetail: {
        folderName: folderName,
        folderid: folderId
      },
      jobDetail: {
        jobLocations: jobMode === 'Remote' ? [] : jobLocation,
        jobTitle: jobTitle,
        maxExp: Number(maxExperience),
        minExp: Number(minExperience),
        jobDescription: updatedJobDescription,
        jobMode: jobMode === 'WFO' ? 'WFO (Work From Office)' : jobMode,
        disabledFields: disabledFields,
        channelName: urlParams.get('cn')
      },
      receiveReplyOn: replyId.trim(),
      selectedCandidatesCount: candidateNo,
      sendMailToContactedProfiles: getSendMailToContactedProfiles(),
      senderEmailId: senderId.trim(),
      status: type === 'DRAFT' ? 'DRAFT' : 'SCHEDULED' ,
      contentPersonalisationType,
      contentPersonalisationGenratedViaAI : contentPersonalisationGenratedViaAI ? 1 : 0,
      selectedContentPersonalisationKey,
      isBlastCampaign: outreachType === 'BLAST' ? true : false,
      siteDomain: extractDomain(),
      isPassiveJob: passiveJobs,
    }

    if (updatedMinSalary !== "") {
      payload.jobDetail.minSalary =  Number(updatedMinSalary);
    }

    if (updatedMaxSalary !== "") {
      payload.jobDetail.maxSalary =  Number(updatedMaxSalary);
    }

    startTime = (Date.now()) / 1000;

    if(resetDetails?.resetCount && resetDetails?.resetCount > 0){
      postResetTrackingData({
        resetCount : resetDetails?.resetCount || 0,
        originalContent: resetDetails?.originalContent || null,
        newContent : getNewContentType() || null,
        campaignInitiationId: campaignCreationQueryData?.campaignInitiationId || "",
      });
    }

    let eventName = "";

    if(type?.toLowerCase() === "draft"){
      eventName = "Save_as_a_Draft";
    } else{
      eventName = "Start_Campaign_Clicked";
    }

    postCampaignData(payload)
      .unwrap()
      .then((res) => {
        if (outreachType === 'SCHEDULED' || outreachType === 'BLAST') {
          let endTime = (Date.now()) / 1000
          if (campaignCreationQueryData?.searchId && campaignCreationQueryData?.childSearchId) {
            eventTracking.update({
            ACTION_NAME: 'send_email',
            API_RESPONSE_CODE: 200,
            API_RESPONSE_TIME: Date.now(),
            PAGE_LOAD_STATUS: "SUCCESS",
            PAGE_LOAD_TIME: endTime - startTime,
            API_REQUEST_TIME: startTime * 1000,
            SEARCH_ID: campaignCreationQueryData.searchId,
            CHILD_SEARCH_ID: campaignCreationQueryData.childSearchId,
            PROFILES_SELECTED: candidateNo,
            PAGE_TYPE: campaignCreationQueryData.triggeredFromPage,
            SUB_UID: userData.recruiterId,
            // "SEARCH_PAGE_VNO": "v4.1",
            PAGE_URL: window.location.href,
            XCODE: userDetails.x_code,
            SESSION_ID: userData.trackingId,
            SITECONTEXT: userData.siteContext,
            LANDING_TIMESTAMP: "",
            CLICK_TIME: Date.now(),
            // DB_VIEW: All,
            EVENT_CREATED_TIME: Date.now(),
            BULK:isBulkCampaign
          })
          postEvent(window.outreach)
          }
          handleFormReset();
          if (outreachType === 'BLAST') { setOpenBlastModal(false) }
        }
        else {
          dispatch(setCampaignId({ campaignId: res.id }));
        }
        const toastMessage = res.message ? res.message : type === 'DRAFT' ? 'Campaign Drafted' : outreachType === 'SCHEDULED' ?  'Campaign Scheduled' :  'Campaign Blasted';
        setToastValue({
          isToastShown: true,
          toastMessage: toastMessage,
          toastKey: 'campaign-started',
          toastSeverity: 'success'
        })
        
        // clevertap event for  Start Campaign and Save as draft
        eventPushFunction(
          {
            eventName,
            data: {
              xcode: userDetails?.x_code || "",
              subuid: userDetails?.recruiter_id || "",
              Channel_Id: userDetails?.channel_id || "",
              subchannel_id: userDetails?.subhchannel_id || "",
              campaign_ID: res.id,
              Outreach_type: "Email",
              Employer_Branding_used: !!media?.logo ? "Yes" : "No",
              Passive_Job_enabled: !!passiveJobs? "Yes" : "No",
              Reset_used: resetDetails?.resetCount || 0,
              Email_Type: getNewContentType(),
              Number_of_Followups: formatedTabStateData?.length > 0 ? formatedTabStateData.length - 1: 0,
              Personal_mailbox_used: senderId?.includes("opportunities") ? "No" : "Yes",
              Profile_Count: candidateNo
            }
          }
        )
        setTimeout(() => {
          window.location.href = `${window.location.protocol}//${window.location.host}${MIDDLEWARE_SLUG}/listing?campaignId=${res.id}`
        },0)
      })
      .catch((err) => {

        if ((err as RTKErrorType<ProfanityWordsErrorType>).status === 406) {
          const newTabStates: TabStatesProps[] = JSON.parse(JSON.stringify(tabState))
          let newJobDescription = JSON.parse(JSON.stringify(jobDescription))
          let profanityData = (err as any).data;
          
          profanityData?.forEach(((item: ProfanityDetailsType) => {
            const index = Number(item.step);
            const selectedTab = newTabStates[index];
            const updatedErrorEmail =item.profanityWords.length ? getErrorContent(item.profanityWords, selectedTab.email) :   selectedTab.email;
            newJobDescription =item.profanityWords.length ? getErrorContent(item.profanityWords, newJobDescription) : newJobDescription;
            const updatedErrorSubject =item.profanityWordsInSubject.length ? getErrorContent(item.profanityWordsInSubject, selectedTab.subject) :   selectedTab.subject;
            selectedTab.showError = true;
            selectedTab.email = updatedErrorEmail;
            selectedTab.subject = updatedErrorSubject;
            selectedTab.profanityWords = item.profanityWords;
            selectedTab.profanityWordsInSubject = item.profanityWordsInSubject;
          }));

          dispatch(setTabStates({ tabState: [...newTabStates] }));
          dispatch(setJobDescription({jobDescription: newJobDescription }))
        }
        else {
          let errMessage = (typeof(err?.data) === "string") ? err.data :  (err as any).data?.message
          setToastValue({
            isToastShown: true,
            toastMessage: errMessage,
            toastKey: 'campaign-couldnot-start',
            toastSeverity: 'error'
          })
        }
      })
      ;
  }


  const handleUpdatePlaceholderValues = (placeholderDetails: LabelValueType[], startCampaign: boolean) => {
    setIsPlaceholderModalOpen(false);
    setPlaceholderValues(placeholderDetails)
    let newTabStates: TabStatesProps[] = tabState;
    placeholderDetails.forEach((placeholder: LabelValueType) => {
      let jobTitle = placeholder.label;
      let prevValue = (placeholderValues.filter(item => item.label === jobTitle))[0]?.value;
      let value = placeholder.value;
    if(value)
        newTabStates = updatedTabStateAfterPlaceholderInput(newTabStates,jobTitle,prevValue,value);
      })

    dispatch(setTabStates({ tabState: [...newTabStates] }));

    if(startCampaign){
      handleCampaignInitiate(campaignType, newTabStates);
    }
  }

  return (
    <>
      <Stack sx={{
        boxShadow: '0px 2px 2px -2px rgba(0, 0, 0, 0.15), 0px 4px 8px -2px rgba(0, 0, 0, 0.08) !important',
        border: `1px solid ${COLOR_MAP.GREY} !important`
      }} bgcolor={COLOR_MAP.WHITE} >
        <Card sx={{
          borderRadius: '0.8rem'
        }}>
          <CardContent
            sx={{
              padding: '0.8rem 1.6rem !important'
            }}
          >
            <Stack spacing={1} direction={'row'} alignItems={'center'} gap={'24px'}>
              <Stack sx={{ cursor: 'pointer' }} direction={'row'} gap={'4px'} onClick={() => setShowHelpDrawer(true)}>
                {HELP_ICON}
                <HelpText>Help</HelpText>
              </Stack>
              <Stack>
                <ProhibitedContent/>
              </Stack>
              <Stack
                justifyContent='end'
                direction='row'
                spacing={1}
                sx={{
                  maxHeight: '4.4rem'
                }}
                width='100%' >
                <Button variant='text' disabled={dissableCampaignInitiation || isDraftCampaign} disableRipple onClick={() => handleCampaignInitiate("DRAFT")}>Save as draft</Button>
                <Button variant='contained' disabled={dissableCampaignInitiation || disableBlast} disableRipple onClick={() => handleCampaignInitiate("")}>Start campaign</Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
      <HelpDrawer showModal={showHelpDrawer} closeModal={() => setShowHelpDrawer(false)} data={faqData} />
      <BasicModal
        handleClose={() => setOpenBlastModal(false)}
        action='Send Now'
        loading={dissableCampaignInitiation}
        handleAction={() => saveCampaignData("")}
        open={openBlastModal}
        heading={campaignName}
        dimensions={{ height: 200, width: 360}}
        styles={{minHeight:"unset"}}
        content={
          <Box sx={{padding: "1.6rem 0"}}>
            <div>Sending this campaign now will pause all active campaigns temporarily until it’s finished.</div>
          </Box>}
      />
   {isPlaceholderModalOpen ?   <CampaignPlaceholderInputList isOpen={isPlaceholderModalOpen} onClose={handleUpdatePlaceholderValues} placeholderValues={placeholderValues}/> : null}
    </>
  )
}

export default BottomPanel;